<template>
  <div id="access-control">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="CRUDTableRef"
          :external-loading="loading"
          :remote-create-item="createItem"
          :remote-update-item="updateItem"
          :remote-delete-item="deleteItem"
          :remote-get-item="getItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :search-key-word="searchKeyWord"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          :show-expand="true"
          :expanded.sync="expanded"
          :single-expand="singleExpand"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
          @update:expanded="handleExpanded"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row>
                <v-col>
                  <div class="mt-5">
                    <v-btn
                      depressed
                      class="mr-5"
                      color="primary"
                      @click="saveRoleMenu(item.id)"
                    >
                      Save
                    </v-btn>
                    <!-- <v-btn
                      depressed
                      class="mr-5"
                      color="secondary"
                      @click="resetRoleMenu(item)"
                    >
                      Reset
                    </v-btn> -->
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <!-- <v-col
                  v-for="(endpointMenuItem, index) in endpointMenuItems"
                  :key="index"
                  class="access-tree"
                >
                  <v-treeview
                    v-model="rootMenu[index]"
                    :items="[endpointMenuItem]"
                    :active="activeArr[index]"
                    selection-type="leaf"
                    selectable
                    return-object
                    open-all
                    activatable
                    @update:active="(e)=>{handleActive(e,index)}"
                    @input="(e)=>onSelected(e,index)"
                  >
                  </v-treeview>
                </v-col> -->
                <v-col
                  class="access-tree"
                >
                  <v-treeview
                    ref="studentMenuSelectionRef"
                    v-model="studentMenuSelection"
                    :items="[endpointMenuItems[0]]"
                    selection-type="leaf"
                    selectable
                    return-object
                    open-all
                    @input="(selectedIitems)=>onSelected(selectedIitems,0)"
                  >
                  </v-treeview>
                  <!--
                    @update:active="(e)=>{handleActive(e,0)}" -->
                </v-col>

                <v-col
                  class="access-tree"
                >
                  <v-treeview
                    ref="coachMenuSelectionRef"
                    v-model="coachMenuSelection"
                    :items="[endpointMenuItems[1]]"
                    selection-type="leaf"
                    selectable
                    return-object
                    open-all
                    @input="(selectedIitems)=>onSelected(selectedIitems,1)"
                  >
                  </v-treeview>
                  <!--
                    @update:active="(e)=>{handleActive(e,1)}" -->
                </v-col>
                <v-col
                  class="access-tree"
                >
                  <v-treeview
                    ref="manageMenuSelectionRef"
                    v-model="manageMenuSelection"
                    :items="[endpointMenuItems[2]]"
                    selection-type="leaf"
                    selectable
                    return-object
                    open-all
                    @input="(selectedIitems)=>onSelected(selectedIitems,2)"
                  >
                  </v-treeview>
                  <!--
                    @update:active="(e)=>{handleActive(e,2)}" -->
                </v-col>
              </v-row>
            </td>
          </template>
        </CRUDTable>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { getCurrentInstance, ref, reactive, onMounted } from 'vue'
import { nextTick } from 'process'
import { createItem, deleteItem, fetchList, getItem, updateItem, updateRoleMenu } from '@/api/sysRole'
import { fetchListByEndpoint } from '@/api/sysMenu'
import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'

const active = ref([])
const store = useStore()
console.log('store', store)
const roleMenus = reactive({
  roleID: -1,
  sysMenus: [],
})

// const rootMenu = reactive({
//   0: [],
//   1: [],
//   2: [],
//   3: [],
//   4: [],
//   5: [],
//   6: [],
//   7: [],
//   8: [],
//   9: [],
// })
const studentMenuSelection = ref([])
const coachMenuSelection = ref([])
const manageMenuSelection = ref([])
const studentMenuSelectionRef = ref(null)
const coachMenuSelectionRef = ref(null)
const manageMenuSelectionRef = ref(null)

// const studentMenuSelectionActive = ref([])
// const coachMenuSelectionActive = ref([])
// const manageMenuSelectionActive = ref([])

// const rootMenu = reactive({
//   0: [],
//   1: [],
//   2: [],
//   3: [],
//   4: [],
//   5: [],
//   6: [],
//   7: [],
//   8: [],
//   9: [],
// })
// const activeArr = reactive({
//   0: [],
//   1: [],
//   2: [],
//   3: [],
//   4: [],
//   5: [],
//   6: [],
//   7: [],
//   8: [],
//   9: [],
// })
const endpointMenuItems = ref([])

onMounted(() => {
  fetchListByEndpoint().then(response => {
    console.log('sysmenu', response)
    endpointMenuItems.value = [...response.data.record]
    console.log('endpointMenuItems', endpointMenuItems.value)
  })
})

const singleExpand = ref(true)
const expanded = []
const loading = ref(false)
const searchKeyWord = ref('')
const organizations = ref([])
const inputConfigs = [
  { md: 6, propName: 'id', label: 'ID', readonly: true },
  { md: 6, propName: 'name', label: 'Name' },
  { md: 6, propName: 'privilegeID', label: 'Privilege' },
  { md: 6, propName: 'remark', label: 'Remark' },
]
const formConfig = {
  title: 'Role',
  headers: [
    { value: 'id', text: 'ID' },
    { value: 'name', text: 'Name' },
    { value: 'privilegeID', text: 'Privilege' },
    { value: 'actions', text: 'Actions', sortable: false },
  ],
}

const CRUDTableRef = ref(null)

const hasExpandedRow = ref(false)

// nextTick would cause the tree-view checkbox flickering
function resetArray() {
  // nextTick(() => {
  // })
  studentMenuSelection.value = []
  coachMenuSelection.value = []
  manageMenuSelection.value = []

  // nextTick(() => {

  //   // studentMenuSelectionActive.value = []
  //   // coachMenuSelectionActive.value = []
  //   // manageMenuSelectionActive.value = []
  // })
}

function handleExpanded(expandedRows) {
  console.log('expandedRows', expandedRows)

  resetArray()
  if (expandedRows.length > 0) {
    // sysEndpointId map with rootMenu index and endpointMenuItems index
    // const sysEndpointIdIndexMapping = {
    //   1000: 0,
    //   1100: 1,
    //   1200: 2,
    // }
    expandedRows[0].sysRoleMenus.forEach(sysRoleMenu => {
      // console.log('sysRoleMenu', sysRoleMenu)
      const nodeEndpointId = sysRoleMenu.sysMenu.sysEndpointID

      // const selectionIndex = sysEndpointIdIndexMapping[nodeEndpointId]
      console.log('nodeEndpointId', nodeEndpointId)
      if (nodeEndpointId === 1000) {
        studentMenuSelection.value.push(sysRoleMenu.sysMenu)

        // studentMenuSelectionActive.value.push(sysRoleMenu.sysMenu)
      } else if (nodeEndpointId === 1100) {
        coachMenuSelection.value.push(sysRoleMenu.sysMenu)

        // coachMenuSelectionActive.value.push(sysRoleMenu.sysMenu)
      } else if (nodeEndpointId === 1200) {
        manageMenuSelection.value.push(sysRoleMenu.sysMenu)

        // manageMenuSelectionActive.value.push(sysRoleMenu.sysMenu)
      }
    })
  }

  // console.log('studentMenuSelectionRef', )
  // if (studentMenuSelectionRef.value) {
  //   studentMenuSelectionRef.value.updateAll()
  // }
  // if (coachMenuSelectionRef.value) {
  //   coachMenuSelectionRef.value.updateAll()
  // }
  // if (manageMenuSelectionRef.value) {
  //   manageMenuSelectionRef.value.updateAll()
  // }
}

// handle checkbox click event, replace all checkbox on selection index
function onSelected(selectedIitems, index) {
  nextTick(() => {
    if (index === 0) {
      studentMenuSelection.value = [...selectedIitems]
    } else if (index === 1) {
      coachMenuSelection.value = [...selectedIitems]
    } else if (index === 2) {
      manageMenuSelection.value = [...selectedIitems]
    }
  })
}

function saveRoleMenu(roleID) {
  console.log('roleID', roleID)
  const sysRoleMenus = []

  // for (let index = 0; index < 10; index += 1) {
  //   if (rootMenu[index] && rootMenu[index].length > 0) {
  //     rootMenu[index].forEach(menuItem => {
  //       sysRoleMenus.push({
  //         SysMenuID: menuItem.id,
  //       })
  //     })
  //   }
  // }
  studentMenuSelection.value.forEach(menuItem => {
    sysRoleMenus.push({
      SysMenuID: menuItem.id,
    })
  })
  coachMenuSelection.value.forEach(menuItem => {
    sysRoleMenus.push({
      SysMenuID: menuItem.id,
    })
  })
  manageMenuSelection.value.forEach(menuItem => {
    sysRoleMenus.push({
      SysMenuID: menuItem.id,
    })
  })

  const postData = {
    id: roleID,
    SysRoleMenus: sysRoleMenus,
  }
  console.log('postData', postData)
  loading.value = true
  updateRoleMenu(postData).then(response => {
    CRUDTableRef.value.fetchData().then(() => {
      handleExpanded([response.data.record])
      loading.value = false
    })
  })
}
function resetRoleMenu(item) {
  console.log('resetRoleMenu', item)

  // handleExpanded([])
  // nextTick(() => {
  //   handleExpanded([item])
  // })
}
function getSelectionName(id, sectionTitle) {
  return `${id}_${sectionTitle}`
}
function handleReset() {
  console.log('handleReset')
}
function onEditDialog(action) {
  console.log('action', action)
}

// 20230301 deprecated handleActive
// not able to handle active from label in current context

// remove item from list if exist,
// add to list if not exist
// function processItem(arr, selected) {
//   const itemIndex = arr.findIndex(item => item.id === selected.id)

//   if (itemIndex !== -1) {
//     arr.splice(itemIndex, 1)
//   } else {
//     arr.push(selected)
//   }
// }

// function handleActive(e, index) {
//   console.log('e, index', e, index)
//   const clickNode = e[0]
//   if (!clickNode) {
//     return
//   }
//   if (index === 0) {
//     const itemIndex = studentMenuSelection.value.findIndex(item => item.id === clickNode.id)

//     if (itemIndex !== -1) {
//       studentMenuSelection.value.splice(itemIndex, 1)
//     } else {
//       studentMenuSelection.value.push(clickNode)
//     }

//     // processItem(studentMenuSelection.value, clickNode)
//     studentMenuSelectionActive.value = []
//   } else if (index === 1) {
//     // coachMenuSelection.value.push(clickNode)
//     processItem(coachMenuSelection.value, clickNode)
//     coachMenuSelectionActive.value = []
//   } else if (index === 2) {
//     // manageMenuSelection.value.push(clickNode)
//     processItem(manageMenuSelection.value, clickNode)
//     manageMenuSelectionActive.value = []
//   }

//   // console.log('rootMenu[index]', rootMenu[index])

//   // activeArr[index].length = 0
// }
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
